import React from 'react';
import PropTypes from 'prop-types';

/**
 * Footer della modale.
*/
export default function Footer({ children }) {
  return (
    <div className="v2-modal__footer">
      {children}
    </div>
  );
}

Footer.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Footer.defaultProps = {
};
